import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import { useEffect, useRef, useState } from "react";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";

const PageId = 5;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const [step, setStep] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_0 = `${baseImages}animation_0.png`;

  const rightSideComponentStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    top: 0,
    transition: "opacity .6s ease-in-out",
    height: "var(--height-1080)",
    width: "var(--width-1920)",
  };

  const stepsTime = [800, 800];

  useEffect(() => {
    if (currentPage === PageId) timeoutRef.current = setTimeout(() => setStep(1), 600);
    else setStep(0);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [currentPage]);

  useEffect(() => {
    if (step > 0 && step <= stepsTime.length) timeoutRef.current = setTimeout(() => setStep((prev) => prev + 1), stepsTime[step - 1]);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title: "Enjoy Entertainment Anytime,\nAnywhere on Any Device",
    description:
      'Experience the freedom of entertainment across\nmultiple devices. With Infosys’ seamless multi-\ndevice integration, viewers can effortlessly switch\nfrom a smartphone to a smart TV or streaming\ndevice without missing a beat.\n\n<b style="text-decoration-line: underline;">Smart Transition</b>\nSwitch between devices like Smart TVs, tablets,\nand smartphones with no interruptions.\n\n<b style="text-decoration-line: underline;">Device-Agnostic Access</b>\nAccess the platform from any device, anytime,\nanywhere.\n\n<b style="text-decoration-line: underline;">Unified Functionality</b>\nEnjoy a synchronized viewing experience across\nall screens.',
    rightSideComponent: (
      <>
        <img src={rightSideImage_0} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 1 ? 1 : 0 }} />
      </>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: {
        gap: "var(--width-16)",
      },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: {
        gap: "var(--width-16)",
      },
    },
  };
};

export default DATA;
